import { useApiClient } from '@esnafai/shared/api';
import { logout, useSession } from '@esnafai/shared/auth';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { t } from '@esnafai/shared/i18n';

type UserMenuProps = {
  name: string;
  roleLabel: string;
  items: Array<{ id: string; label: string; to?: string; onSelect?: () => void }>;
};

// The header's user menu (merchant screens §2): the name, the role, Bildirim ayarları and Çıkış yap. Logging out
// clears the cache and the session, which closes the stream (the LiveProvider follows the session), then /login.
export function useUserMenu(): UserMenuProps | undefined {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const router = useRouter();
  const { principal } = useSession();
  if (principal === null || !('merchant' in principal)) return undefined;

  async function signOut() {
    try {
      await logout({ api, queryClient });
    } finally {
      await router.navigate({ to: '/login' });
    }
  }

  return {
    name: principal.user.name,
    roleLabel: t(`roles.${principal.role}`),
    items: [
      {
        id: 'notification-settings',
        label: t('nav.notificationSettings'),
        to: '/settings/notifications',
      },
      { id: 'logout', label: t('nav.logout'), onSelect: () => void signOut() },
    ],
  };
}
